import { createReducer } from '@reduxjs/toolkit';
import {
  getContactInfo,
  getLanguagesInfo,
  getPublicKey,
  getPubliclyAvailableShifts,
  getPublicPharmacyRatingItems,
  getPublicProfessionalRatingItems,
  istermsAgreed,
  logout,
  registerSmartLogin,
  resetLongTermContractAttributes,
  setBiometricEnabled,
  setBookedContractDates,
  setLoading,
  setLongTermContractAttributes,
  setNearbyProps,
  setSelectedIds,
  setSelectionMode,
  setShowBiometric,
  setTourCompleted,
  utilResetValue,
} from '../actions';
import {
  IAllLanguages,
  INearbyLocation,
  IPharmacyRatings,
  IProfessionalRatingModel,
  ILongContractAttributes,
} from '../models';
import { Agencies, defaultCenter } from '../helpers/Constants';
import { IPublicAvailableShifts } from '../models/Models';
import { ILongTermUtils } from '../models/UtilModel';

export interface IUtils {
  termsAndConditions: boolean;
  publicAvailableShifts: IPublicAvailableShifts;
  contacts: any;
  languages: Array<IAllLanguages>;
  loading: Array<string>;
  userHash: string | null;
  publicKey: string;
  isBiometricEnabled: boolean;
  isTourCompleted: boolean;
  showBiometric: boolean;
  nearbyLocation: INearbyLocation;
  selectedIds: Array<string>;
  selectionMode: {
    pharmacyId: string;
    showCheckbox: boolean;
    activeView?: string;
    isAutoSyncRecord?: boolean;
  };
  pharmacyRatingItems: IPharmacyRatings;
  professionalRatingItems: IProfessionalRatingModel;
  longTermContractAttributes: ILongTermUtils;
  bookedContractDates: Array<string>;
}

const initialState: IUtils = {
  bookedContractDates: [],
  longTermContractAttributes: {
    shiftContractAttributes: [],
    startDate: null,
    endDate: null,
    defaultEndTime: null,
    defaultStartTime: null,
  },
  professionalRatingItems: {
    displayDetailForm: false,
    professionalRatingItems: [],
    professionalRatingQuestions: [],
    favorite: false,
  },
  pharmacyRatingItems: {
    favorite: false,
    displayDetailForm: false,
    pharmacyRatingItems: [],
    pharmacyRatingQuestions: [],
  },
  publicAvailableShifts: {
    data: [],
    page: 1,
    itemPerPage: 1,
    totalCount: 0,
  },
  termsAndConditions: false,
  selectionMode: { pharmacyId: '', showCheckbox: false, activeView: '' },
  contacts: null,
  languages: [],
  loading: [],
  userHash: null,
  publicKey: '',
  isBiometricEnabled: false,
  isTourCompleted: true,
  showBiometric: false,
  nearbyLocation: {
    latitude: defaultCenter.lat,
    longitude: defaultCenter.lng,
    showNearBy: false,
  },
  selectedIds: [],
};

const utilsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getContactInfo.fulfilled, (state, action) => {
      state.contacts = action.payload;
    })
    .addCase(setLoading, (state, action) => {
      state.loading = action.payload;
    })
    .addCase(getPublicKey.fulfilled, (state, action) => {
      state.publicKey = action.payload?.publicKey;
    })
    .addCase(registerSmartLogin.fulfilled, (state, action) => {
      state.userHash = action.payload?.userHash;
    })
    .addCase(setBiometricEnabled, (state, action) => {
      state.isBiometricEnabled = action.payload as boolean;
    })
    .addCase(setTourCompleted, (state, action) => {
      state.isTourCompleted = action.payload as boolean;
    })
    .addCase(logout.fulfilled, (state) => {
      state.publicKey = '';
      state.userHash = null;
    })
    .addCase(setShowBiometric, (state, action) => {
      state.showBiometric = action.payload;
    })
    .addCase(setNearbyProps, (state, action) => {
      state.nearbyLocation = action.payload;
    })
    .addCase(getLanguagesInfo.fulfilled, (state, action) => {
      state.languages = action.payload;
    })
    .addCase(getPubliclyAvailableShifts.fulfilled, (state, action) => {
      state.publicAvailableShifts = action.payload;
    })
    .addCase(setSelectionMode, (state, action) => {
      state.selectionMode = action.payload;
    })
    .addCase(istermsAgreed, (state, action) => {
      state.termsAndConditions = action.payload;
    })
    .addCase(getPublicPharmacyRatingItems.fulfilled, (state, action) => {
      state.pharmacyRatingItems = action.payload;
    })
    .addCase(getPublicProfessionalRatingItems.fulfilled, (state, action) => {
      state.professionalRatingItems = action.payload;
    })
    .addCase(setLongTermContractAttributes, (state, action) => {
      state.longTermContractAttributes = action.payload;
    })
    .addCase(setBookedContractDates, (state, action) => {
      state.bookedContractDates = action.payload;
    })
    .addCase(resetLongTermContractAttributes, (state) => {
      state.longTermContractAttributes =
        initialState.longTermContractAttributes;
    })
    .addCase(utilResetValue, (state, action) => {
      action.payload.map(
        (item) =>
          // @ts-expect-error: REDUCERS HAVE WRITABLE INNATE TYPE
          (state[item] =
            initialState[item as keyof typeof initialState])
      );
    })
    .addCase(setSelectedIds, (state, action) => {
      state.selectedIds = action.payload;
    });
});

export default utilsReducer;
